import * as ruleManageDetail from '../services/ruleManageDetail';

export default {
  namespace: 'ruleManageDetail',

  state: {
    getRuleDetailList: null,
    addRuleDetailList: null,
    editRuleManaList: null,
    deleteRuleManaList: null,
    deleteBatchRuleManaList: null,
    allFieldPackageList: null,
    fieldPackageDetailList: null,
    importSingle: null,
    importMultiple: null,
  },

  effects: {
    *getRuleDetailList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.getRuleDetailList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          getRuleDetailList: response,
        },
      });
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },

    *addRuleDetailList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.addRuleDetailList,
        values,
      );
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addRuleDetailList: response,
        },
      });
    },

    *editRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.editRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editRuleManaList: response,
        },
      });
    },
    *deleteRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.deleteRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRuleManaList: response,
        },
      });
    },
    *deleteBatchRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.deleteBatchRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteBatchRuleManaList: response,
        },
      });
    },
    *getAllFieldPackage({}, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.getAllFieldPackage,
      );
      yield put({
        type: 'save',
        payload: {
          allFieldPackageList: response,
        },
      });
    },
    *getFieldPackageDetails({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.getFieldPackageDetails,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          fieldPackageDetailList: response,
        },
      });
    },
    *importSingle({ payload: { values, id }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.importSingle,
        values,
        id,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          importSingle: response,
        },
      });
    },
    *importMultiple({ payload: { values, id }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManageDetail.importMultiple,
        values,
        id,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          importMultiple: response,
        },
      });
    },
    // 批量粘贴规则数据
    *pasteRule({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(ruleManageDetail.pasteRule, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          pasteData: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
